import { AppDate } from '../envTypes';

export type WithID<T> = T & { id: string };

export interface ModelBase {
  createdAt: AppDate;
  updatedAt: AppDate;
}

export enum PopPlatform {
  Psl = 'psl',
  PopStore = 'popstore',
}

export enum Platform {
  PopshopLive = 'popshop.live',
  PopStore = 'pop.store',
}

export enum ShippingFeePayer {
  Buyer = 'Buyer',
  Seller = 'Seller',
  Popshop = 'Popshop',
}

export enum CommissionFeeType {
  Rate = 'RATE',
  Fixed = 'FIXED',
}

export enum ShippingIntegrationType {
  Shippo = 'shippo',
  ShippoPlatform = 'shippo_platform',
}

export enum ShippingMode {
  Shipping = 'shipping',
  Pickup = 'pickup',
}

export interface ShowCustomization {
  primaryLightColor?: string;
  primaryDarkColor?: string;
  lightingBoltImages?: string[];
  lightingBoltButtonImage?: string;
  disableLightingBoltForAll?: boolean;
  tippingEnabled?: boolean;
}

export enum ShowPermission {
  All = 'all',
  Follower = 'follower',
  Subscriber = 'subscriber',
  None = 'no-one',
}

export enum OpenBoxMode {
  FixedDuration = 'FIXED_DURATION',
  FixedTimeOfWeek = 'FIXED_TIME_OF_WEEK',
}

export enum ShippingSolution {
  SHIP_WITH_POPSHOP = 'SHIP_WITH_POPSHOP',
  ARRANGE_MY_OWN_SHIPPING = 'ARRANGE_MY_OWN_SHIPPING',
}

export enum UserRole {
  Moderator = 'moderator',
  Seller = 'seller',
  SystemAdmin = 'system-admin',
  User = 'user',
  CreatorAdmin = 'creator-admin',
  Finance = 'finance',
  AgencyAdmin = 'agency-admin',
  AgencyUser = 'agency-user',
  ItAdmin = 'it-admin',
  Developer = 'developer',
  Marketing = 'marketing',
  Support = 'support',
}

/**
 * when support new ShipmentProvider
 * should change order-shipment.service.ts.getShippoAccount and change firebase config
 */
export enum ShipmentProvider {
  UPS = 'ups',
  USPS = 'usps',
  USPS_FIRST = 'usps_first',
}

export interface RequireRedaction {
  requireRedaction?: boolean;
}

export interface FromTemplate {
  // if true, this doc is copied from a template profile
  fromTemplate?: boolean;
}

export enum IdPrefix {
  TokenOrder = 'token_ord_',
}
